<template>
  <div>
    <v-dialog persistent v-model="show" width="95%" max-width="1600">
      <v-card>
        <v-card-title primary-title class="headline grey lighten-2">
          Detalhamento da Renegociação
        </v-card-title>

        <v-card-text>
          <div v-if="loading" class="text-xs-center">
            Carregando...
          </div>

          <v-data-table
            v-else
            :headers="headers"
            :items="parcelas"
            :pagination.sync="pagination"
            :rows-per-page-items="pageOptions"
            rows-per-page-text="Linhas por página"
            no-data-text="Não há registros"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <tr>
                <td>{{ props.item.fatura }}</td>
                <td>{{ props.item.processo }}</td>
                <td>{{ props.item.parcela }}</td>
                <td>{{ formatMoney(props.item.valorParcela) }}</td>
                <td>{{ formatMoney(props.item.saldoParcela) }}</td>
                <td>{{ formatDate(props.item.dataVencimento) }}</td>
                <td>{{ formatDate(props.item.dataLiquidacao) }}</td>
                <td>{{ formatDate(props.item.dataInclusao) }}</td>
                <td>{{ formatDate(props.item.dataExclusao) }}</td>
                <td>
                  <div class="coluna-renegoc">
                    <div class="resumo-faturas">
                      <div class="conteudo-faturas">
                        <span v-if="linhaExpandida !== props.item.id">
                          {{
                            formatFaturasResumidas(
                              props.item.faturasProcRenegoc
                            )
                          }}
                        </span>

                        <div v-else class="faturas-expandida">
                          <div
                            v-for="(grupo, index) in agruparFaturas(
                              props.item.faturasProcRenegoc
                            )"
                            :key="index"
                          >
                            {{ grupo.join(", ") }}
                          </div>
                        </div>

                        <v-icon
                          v-if="
                            props.item.faturasProcRenegoc &&
                              props.item.faturasProcRenegoc.split(',').length >
                                3
                          "
                          small
                          @click="toggleFaturas(props.item)"
                        >
                          {{
                            linhaExpandida === props.item.id
                              ? "keyboard_arrow_up"
                              : "keyboard_arrow_down"
                          }}
                        </v-icon>
                      </div>
                    </div>
                  </div>
                </td>
                <td>{{ props.item.situacao }}</td>
              </tr>
            </template>
          </v-data-table>
          <template v-slot:pageText="props">
            {{ props.pageStart }} - {{ props.pageStop }} de
            {{ props.itemsLength }}
          </template>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click="close">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import { getDetalhamentoRenegociacao } from "@/services/beneficiario";

export default {
  name: "ModalConsultaRenegociacao",

  props: {
    show: Boolean,
    faturaId: Number
  },

  data() {
    return {
      loading: false,
      parcelas: [],
      linhaExpandida: null,
      pageOptions: [5, 10, 25, { value: -1, text: "Todos" }],
      pagination: {
        page: 1,
        rowsPerPage: 5
      },
      headers: [
        { text: "Fatura", value: "fatura" },
        { text: "Processo", value: "processo" },
        { text: "Parcela", value: "parcela" },
        { text: "Valor da parcela", value: "valorParcela" },
        { text: "Saldo da parcela", value: "saldoParcela" },
        { text: "Data de vencimento", value: "dataVencimento" },
        { text: "Data de liquidação", value: "dataLiquidacao" },
        { text: "Data de inclusão", value: "dataInclusao" },
        { text: "Data de exclusão", value: "dataExclusao" },
        { text: "Faturas do processo de negoc.", value: "faturasProcRenegoc" },
        { text: "Situação", value: "situacao" }
      ]
    };
  },

  watch: {
    show(value) {
      if (value) {
        this.buscarDetalhamento();
      }
    },

    pagination: {
      handler() {
        this.linhaExpandida = null;
      },
      deep: true
    }
  },

  methods: {
    async buscarDetalhamento() {
      this.loading = true;

      try {
        this.parcelas = await getDetalhamentoRenegociacao(this.faturaId);
      } finally {
        this.loading = false;
      }
    },

    formatDate(data) {
      return data ? moment(data).format("DD/MM/YYYY") : "-";
    },

    formatMoney(valor) {
      return valor != null
        ? Number(valor).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL"
          })
        : "-";
    },

    toggleFaturas(item) {
      this.linhaExpandida = this.linhaExpandida === item.id ? null : item.id;
    },

    formatFaturasResumidas(faturas) {
      if (!faturas) return "-";

      const lista = faturas.split(",");

      return lista.length > 3 ? lista.slice(0, 3).join(", ") : faturas;
    },

    agruparFaturas(faturas) {
      if (!faturas) return [];

      const lista = faturas.split(",").map(item => item.trim());
      const grupos = [];

      for (let i = 0; i < lista.length; i += 3) {
        grupos.push(lista.slice(i, i + 3));
      }

      return grupos;
    },

    close() {
      this.$emit("close");
    }
  }
};
</script>
<style scoped>
.coluna-renegoc {
  max-width: 200px;
}

.resumo-faturas {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}

.resumo-faturas i {
  cursor: pointer;
  font-size: 10px;
  margin-top: 2px;
  flex-shrink: 0;
}

.conteudo-faturas {
  flex: 1;
}

.conteudo-faturas span {
  white-space: normal;
}

.faturas-expandida {
  max-height: 80px;
  overflow-y: auto;
  line-height: 16px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.faturas-expandida::-webkit-scrollbar {
  width: 0;
  height: 0;
}
</style>
